<template>
    <div>
        <h3 class="title is-3" style="margin-top:8px;text-transform: capitalize;">
            <router-link to="/tools/featured">
                <b-icon icon="chevron-left" size="is-small"></b-icon>
            </router-link> &nbsp;
            Sub Menu Navigation - {{$route.params.type}}
        </h3>
        <div class="columns">
            <div :key="item.category" class="column border-right" v-for="item in categorisedTopics">
              <p class="center-text">
                {{item.category}}
              </p>
              <draggable class="min-height" v-model="item.items" :options="{group:'topics'}">
                  <div v-for="element in item.items" :key="element.id">
                      <a class="panel-block">
                        <span class="panel-icon">
                          <img :src="element.image_url">
                        </span>
                        {{element.name}}
                      </a>
                  </div>
              </draggable>
            </div>
        </div>
        <button @click="savePositions" class="button is-primary">Save Changes</button>
        <loading v-if="loading"></loading>
    </div>
</template>

<script>
import { GET_TOPICS, UPDATE_POSITIONS } from "@/store/actions";
import draggable from "vuedraggable";
import loading from "@/components/Loading.vue"

export default {
  name: "FeaturedSub",
  components: {
    draggable,
    loading
  },
  data() {
    return {
      categorisedTopics: null,
      loading: false
    };
  },
  computed: {
    data() {
      return this.$store.state.topics.data;
    },
    topics() {
      const { type } = this.$route.params;
      if (!this.data) {
        return null;
      }

      // properly detach
      let topics = JSON.parse(JSON.stringify(this.data));

      topics = topics.filter(
        x => x.enabled && x.sport.toLowerCase() !== "minor"
      );
      if (type !== "all") {
        topics = topics.filter(x => x.sport.toLowerCase() === type);
      }

      return topics;
    },
    categories() {
      const { type } = this.$route.params;
      if (type === "football") {
        return ["South Africa", "Rest Of Africa", "Europe", "Internationals"];
      } else if (type === "rugby") {
        return ["South Africa", "Europe", "Regional", "International"];
      } else if (type === "cricket") {
        return ["Series & Tours", "Countries", "SA Domestic"];
      } else if (type === "golf" || type === "tennis") {
        return ["Majors"];
      } else if (type === "motorsport") {
        return [];
      }
    }
  },
  mounted() {
    if (!this.topics || this.topics.length <= 0) {
      this.$store.dispatch(GET_TOPICS).then(res => {
        this.$nextTick(() => {
          this.initialiseTopics();
        });
      });
    } else {
      this.initialiseTopics();
    }
  },
  methods: {
    initialiseTopics(topics) {
      let data = [];
      for (let i = 0; i < this.categories.length; i++) {
        const category = this.categories[i];
        data.push({
          category: category,
          items: this.topics.filter(
            x =>
              x.category !== null &&
              x.category.toLowerCase() === category.toLowerCase()
          )
        });
      }
      data.push({
        category: "Others",
        items: this.topics.filter(x => x.category === null)
      });

      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].items.length; j++) {
          data[i].items[j].position = data[i].items[j].web_position;
        }

        data[i].items = data[i].items.sort((a, b) => a.position - b.position);
      }

      this.categorisedTopics = data;
    },
    savePositions() {
      let payload = [];
      for (let i = 0; i < this.categorisedTopics.length; i++) {
        for (let j = 0; j < this.categorisedTopics[i].items.length; j++) {
          const element = this.categorisedTopics[i].items[j];
          payload.push({
            id: element.id,
            web_position: j + 1
          });
        }
      }

      this.loading = true;

      this.$store
        .dispatch(UPDATE_POSITIONS, {
          type: "sub",
          sport: this.$route.params.type,
          payload
        })
        .then(res => {
          if (res.status === 204) {
            this.$success("Positions have been updated successfully");
            this.$store.dispatch(GET_TOPICS).then(res => {
              this.$nextTick(() => {
                this.initialiseTopics();
              });
            });
          } else {
            this.$warning("Something went wrong, please try again");
          }
        })
        .catch(err => {
          this.$error("An error has occured, please try again");
        }).finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.border-right {
  border-right: 1px solid gray;
}
.center-text {
  text-align: center;
}
.min-height{
  min-height: 500px;
}
</style>